import React, { Component } from 'react';
import loadData from './search_page_state_manager';

// eslint-disable-next-line react/prefer-stateless-function
class SearchPage extends Component {
  static loadData(store) {
    return loadData(store);
  }

  render() {
    return (
      <section className="search">
        <div id="faceteddata">
          <span>Filter results by</span>
        </div>
        <div id="resultdata" />
      </section>
    );
  }
}

export default SearchPage;
